//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCButton from '@/shared/components/FCButton.vue';
import FinancingFeature from '~/components/Financing_Features.vue';
import FinancingMetrics from '~/components/Financing_Metrics.vue';
import FCImage from '~/components/FCImage.vue';

export default {
  name: 'Financing_Details',
  components: {
    FinancingFeature,
    FinancingMetrics,
    FCImage,
    FCButton,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
};
